import image1 from "src/assets/images/opportunities/how-it-works/search-select.png";
import { processStepsTrns } from "../trns";

export const PROCESS_STEPS = [
  {
    id: "search-select",
    title: { i18nKey: processStepsTrns.searchAndSelectTitle },
    info: [
      {
        id: "use-filters",
        subtitle: {
          i18nKey: processStepsTrns.searchAndSelectUseFiltersSubtitle,
        },
        description: {
          i18nKey: processStepsTrns.searchAndSelectUseFiltersDesc,
        },
        image: { url: image1, title: "image" },
        isList: true,
      },
      {
        id: "review-offers",
        subtitle: {
          i18nKey: processStepsTrns.searchAndSelectReviewOffersSubtitle,
        },
        description: {
          i18nKey: processStepsTrns.searchAndSelectReviewOffersDesc,
        },
      },
    ],
  },

  {
    id: "purchase",
    title: { i18nKey: processStepsTrns.purchaseTitle },
    info: [
      {
        id: "click",
        subtitle: { i18nKey: processStepsTrns.purchaseClickSubtitle },
        description: { i18nKey: processStepsTrns.purchaseClickDesc },
      },
    ],
  },

  {
    id: "agreement",
    title: { i18nKey: processStepsTrns.agreementConclusionTitle },
    info: [
      {
        id: "subtitle",
        description: { i18nKey: processStepsTrns.agreementConclusionDesc },
      },
      {
        id: "preliminary",
        subtitle: {
          i18nKey: processStepsTrns.agreementConclusionPreliminarySubtitle,
        },
        description: {
          i18nKey: processStepsTrns.agreementConclusionPreliminaryDesc,
        },
      },
      {
        id: "signing",
        subtitle: {
          i18nKey: processStepsTrns.agreementConclusionSigningSubtitle,
        },
        description: {
          i18nKey: processStepsTrns.agreementConclusionSigningDesc,
        },
      },
      {
        id: "payment",
        subtitle: {
          i18nKey: processStepsTrns.agreementConclusionPaymentSubtitle,
        },
        description: {
          i18nKey: processStepsTrns.agreementConclusionPaymentDesc,
        },
      },
      {
        id: "document-transfer",
        subtitle: {
          i18nKey: processStepsTrns.agreementConclusionDocumentTransferSubtitle,
        },
        description: {
          i18nKey: processStepsTrns.agreementConclusionDocumentTransferDesc,
        },
      },
    ],
  },

  {
    id: "completion",
    title: { i18nKey: processStepsTrns.completionTitle },
    info: [
      {
        id: "confirmation",
        subtitle: {
          i18nKey: processStepsTrns.completionConfirmationSubtitle,
        },
        description: {
          i18nKey: processStepsTrns.completionConfirmationDesc,
        },
      },
      {
        id: "buyer-support",
        subtitle: {
          i18nKey: processStepsTrns.completionBuyerSupportSubtitle,
        },
        description: {
          i18nKey: processStepsTrns.completionBuyerSupportDesc,
        },
      },
    ],
  },

  {
    id: "business-launch",
    title: { i18nKey: processStepsTrns.businessLaunchTitle },
    info: [
      {
        id: "implementation",
        subtitle: {
          i18nKey: processStepsTrns.businessLaunchImplementationSubtitle,
        },
        description: {
          i18nKey: processStepsTrns.businessLaunchImplementationDesc,
        },
      },
      {
        id: "scaling",
        subtitle: {
          i18nKey: processStepsTrns.businessLaunchScalingSubtitle,
        },
        description: {
          i18nKey: processStepsTrns.businessLaunchScalingDesc,
        },
      },
    ],
  },
];
